import React from 'react';
import styles from './SurveyUpdatedPopup.module.css';
import Icon from '../../../../campaigns/components/Icon';

export default ({ surveyAlreadyUpdatedSocket, isAdmin, surveysState }) => {
  const getQuestionIcon = block => {
    let icon = block.type;

    if (block.type === 'checkboxes' || block.type === 'mc_question')
      icon = 'multiple-choice';
    if (block.type === 'slider') icon = 'rating';
    if (block.rankAnswers) icon = 'ranking';
    if (block.type === 'iframe') icon = 'showcase-website';
    if (block.type === 'open_question') icon = 'short-text';

    return icon;
  };

  const getQuestionPreviews = questionId => {
    const question =
      surveysState &&
      surveysState.survey &&
      surveysState.survey.questions &&
      surveysState.survey.questions[questionId];

    const questionSurveyLists =
      surveysState && surveysState.surveyLists && questionId
        ? surveysState.surveyLists.find(sL => sL.id === questionId)
        : null;

    if (!question) return null;

    return (
      <div className={styles.questionWrapContainerPreview}>
        <div className={styles.questionContainerPreview}>
          <Icon
            type={getQuestionIcon(question)}
            style={{
              color: '#5200f1',
              marginLeft: '5px',
              marginRight: '5px',
              fontSize: '10px'
            }}
          />
          <span>{questionSurveyLists.formattedGlobalIndex}.</span>
        </div>
      </div>
    );
  };

  const changedQuestionPreview = getQuestionPreviews(
    surveyAlreadyUpdatedSocket &&
      surveyAlreadyUpdatedSocket.additionalData &&
      surveyAlreadyUpdatedSocket.additionalData.questionId
  );

  return (
    <div className={styles.container}>
      <div>
        <span className={styles.name}>
          Attention! Survey update in progress by another account
        </span>
      </div>
      <div className={styles.baseQuestionContainer}>
        <div className={styles.basedOnDataText}>
          It looks like this survey is currently being edited by someone else.{' '}
          {isAdmin &&
          surveyAlreadyUpdatedSocket &&
          surveyAlreadyUpdatedSocket.additionalData &&
          surveyAlreadyUpdatedSocket.additionalData.clientEmail ? (
            <span>
              (client account:{' '}
              <strong>
                {surveyAlreadyUpdatedSocket.additionalData.clientEmail}
              </strong>
              )
            </span>
          ) : null}
        </div>{' '}
        {surveyAlreadyUpdatedSocket &&
        surveyAlreadyUpdatedSocket.additionalData &&
        surveyAlreadyUpdatedSocket.additionalData.questionId &&
        changedQuestionPreview ? (
          <>
            <div className={styles.basedOnDataText} style={{ marginTop: 10 }}>
              The question currently being updated in that session might affect
              your changes:
            </div>
            {changedQuestionPreview}{' '}
          </>
        ) : null}
        <div className={styles.basedOnDataText} style={{ marginTop: 10 }}>
          To make sure your input isn’t lost, please refresh the page before
          continuing.
        </div>{' '}
      </div>
      <div className={styles.actiosButtonContainer}>
        <div
          className={styles.actionButton}
          role="presentation"
          onClick={() => window.location.reload()}
        >
          Refresh page
        </div>
      </div>
    </div>
  );
};
